import { useContext } from "react";
import {
  Box,
  Paper,
  Typography,  
} from "@mui/material";
import { AssistenciasContext } from "../../contexts/assistencias-context";
import "react-datepicker/dist/react-datepicker.css";
import { MdReport } from "react-icons/md";
import AssistenciaProblema from "./assistencia-problema";

export default function AssistenciaTabProblema() {

  const {
    constantes,
  } = useContext(AssistenciasContext);

  return (
    <Box component={Paper}>
      <Box
        display="flex"
        alignItems="center"
        p={2}
        height={50}
        sx={{ backgroundColor: "rgba(59, 134, 124, 0.08)" }}
      >
        <Typography variant="h1" fontSize={22} fontWeight="sembold">
          <MdReport size={25} style={{ marginBottom: "5px", marginRight: "8px" }} />
          {constantes.CadastrarProblema}
        </Typography>
      </Box>
      <AssistenciaProblema/>
  </Box>
  );
}
